module.exports = __webpack_public_path__ + "img/gift6.56087dbb.png";